import React from "react";

import "../ListView.scss";
import SharedWith from "../../SharedWith/SharedWith";
import Dropdown from "../../UI/DropDown/DropDown";
import CheckBox from "../../UI/CheckBox/CheckBox";
import Pin from "../../UI/Pin/Pin";
import ItemNameIcon from "./ItemNameIcon/ItemNameIcon";
import ProfileWithName from "./ProfileWithName/ProfileWIthName";
import { getName, getIntials, getParsedDate } from "../../../helper";
import RightArrow from "../../../assets/icons/arrows/chevron-right.svg";

import folderColor1 from "../../../assets/icons/small_folder_icon/folder_color-1.svg";
import folderColor2 from "../../../assets/icons/small_folder_icon/folder_color-2.svg";
import folderColor3 from "../../../assets/icons/small_folder_icon/folder_color-3.svg";
import folderColor4 from "../../../assets/icons/small_folder_icon/folder_color-4.svg";
import folderColor5 from "../../../assets/icons/small_folder_icon/folder_color-5.svg";
import folderColor6 from "../../../assets/icons/small_folder_icon/folder_color-6.svg";
import folderColorPrimary from "../../../assets/icons/small_folder_icon/folder_primary.svg";
import filePrimarary from "../../../assets/icons/file_pdf.svg";

const colors = {
  "#ff9ead": folderColor1,
  "#ffa575": folderColor2,
  "#ffda6b": folderColor3,
  "#86e575": folderColor4,
  "#6de4d2": folderColor5,
  "#c09eff": folderColor6,
  "#cbd1fe": folderColorPrimary,
};

const listViewRows = (props) => {
  const getContentRole = (userRoleId) => {
    const folder = props.item;
    if (userRoleId === 1 || userRoleId === 2) {
      return [true, { role: "Owner" }];
    } else if (folder) {
      const createUserId = folder.createdBy.id;
      const logUserId = props.currentUserInfo.id;
      let returnedVal;
      if (logUserId === createUserId) {
        returnedVal = [true, { role: "Owner" }];
      } else {
        const sharedUsers = folder.sharedFolder.map((sharedItem) => {
          return {
            id: sharedItem.user.id,
            role: sharedItem.userRole.name,
          };
        });
        const getAccess = sharedUsers.find(
          (sharedUser) =>
            sharedUser.id === logUserId &&
            (sharedUser.role === "Owner" || sharedUser.role === "Collaborator")
        );
        returnedVal = getAccess ? [true, getAccess] : [false];
      }
      return returnedVal;
    }
  };

  return (
    <tr
      key={props.item.folderId || props.item.id}
      className={`${props.size ? "folderlist-row" : "list-view-row"} ${props.checked ? "folderlist-checked" : ""}`}
      onMouseOver={
        props.isColumns.isPinned
          ? () => props.pinOverHandler(props.item.folderId)
          : null
      }
      onMouseOut={
        props.isColumns.isPinned
          ? () => props.pinOutHandler(props.item.folderId)
          : null
      }
      onClick={props.click}
    >
      {/* Files */}

      {props.isColumns.isTitle ? (
        <td className={props.size ? "d-flex" : null}>
          {props.isColumns.isCheckbox ? (
            <CheckBox
              folderId={props.item.folderId || props.item.id}
              checkHandler={() => props.checkHandler(props.item.folderId)}
              checked={props.checked}
            />
          ) : null}
          <ItemNameIcon
            itemIcon={
              props.isFolder
                ? colors[
                    props.item.color.name ||
                      props.item.color.colorCode ||
                      "#cbd1fe"
                  ]
                : filePrimarary
            }
            item={props.item}
            isFolder={props.isFolder}
            rootFolderId={props.rootFolderId}
            isArchivedView={props.isArchivedView}
            onDocumentClick={props.onDocumentClick}
            {...props}
          />
          {props.isColumns.isPinned ? (
            <Pin
              checkPin={props.checkPin}
              pinHandler={() =>
                props.pinHandler(
                  props.item.folderId,
                  props.checkPin,
                  props.item.title,
                  props.item.parentFolder.id
                )
              }
              folderId={props.item.folderId}
              hoverId={props.hoverId}
            />
          ) : null}
        </td>
      ) : null}

      {/* Document Type */}
      {props.isColumns.isDocumentType ? <td>{props.item.title}</td> : null}

      {/* Tag management */}
      {/* Name */}
      {props.isColumns.isTagManagement ? <td>{props.item.name}</td> : null}

      {/* Status */}
      {props.isColumns.isActive ?
        <td>
          {props.item.isActive ? (
            <div
              className="btn-active"
            >
              Active
            </div>
          ) : (
            <div
              className="btn-deactive"
            >
              Inactive
            </div>
          )}
        </td>
      : null}

      {/* Status */}
      {props.isColumns.isStatus ? (
        <td>
          {props.item.status.name === "Active" ? (
            <div
              className="btn-active"
              // onClick={() =>
              //   props.setStatus(
              //     props.item.id,
              //     props.item.status.name,
              //     props.item.title
              //   )
              // }
            >
              {props.item.status.name}
            </div>
          ) : (
            <div
              className="btn-draft"
              // onClick={() =>
              //   props.setStatus(
              //     props.item.id,
              //     props.item.status.name,
              //     props.item.title
              //   )
              // }
            >
              {props.item.status.name}
            </div>
          )}
        </td>
      ) : null}

      {/* Activity */}
      {props.isColumns.isActivity ? (
        <td>
          {props.activity}
         
        </td>
      ) : null}

      {/* Username */}

      {props.isColumns.isUserName ? (
        <td>

        <ProfileWithName
            sKey={props.item.folderId || props.item.id}
            nameIntial={getIntials(props.item.modifiedBy)}
            personName={getName(props.item.modifiedBy)}
            profile={props.item.modifiedBy.profile.image}
            isPopover={props.isColumns.isPopover}
            role={
              props.item.modifiedBy.profile
                ? props.item.modifiedBy.profile.role.name
                : ""
            }
          />

        </td>
      ) : null }

      {/* Added by */}
      {props.isColumns.isAddedBy ? (
        <td>
          <ProfileWithName
            sKey={props.item.folderId || props.item.id}
            nameIntial={getIntials(props.item.createdBy)}
            personName={getName(props.item.createdBy)}
            profile={props.item.createdBy.profile.image}
            isPopover={props.isColumns.isPopover}
            role={
              props.item.createdBy.profile
                ? props.item.createdBy.profile.role.name
                : ""
            }
          />
        </td>
      ) : null}

      {/* Vendor */}
      {props.isColumns.isVendor ? <td>{props.item.vendor}</td> : null}

      {/* Starts on */}
      {props.isColumns.isStartsOn ? <td>{props.item.startsOn}</td> : null}

      {/* Ends on */}
      {props.isColumns.isEndOn ? <td>{props.item.endOn}</td> : null}

      {/* Last modified_ts */}
      {props.isColumns.isLastModified ? (
        <td>{getParsedDate(props.item.modifiedTs)}</td>
      ) : null}

      {/* Shared With */}
      {props.isColumns.isShared ? (
        <td>
          <SharedWith
            itemId={props.item.folderId || props.item.id}
            item={props.item}
            isPopover={props.isColumns.isPopover}
            isFolder={props.isFolder}
            updatedSharedWith={props.updatedSharedWith || []}
          />
        </td>
      ) : null}
      {/* Locations */}
      {props.isColumns.isLocation ? (
        <td>
          <div className="d-flex text-col-3">
            <div>Files</div>
            {props.isFolder ? (
              <div>
                {props.item.rootTitle && (
                  <img
                    src={RightArrow}
                    alt="Left-arrow"
                    width="16"
                    height="16"
                  />
                )}
                {props.item.rootTitle}
              </div>
            ) : (
              <div>
                <img src={RightArrow} alt="Left-arrow" width="16" height="16" />
                {props.item.rootTitle}
                <img src={RightArrow} alt="Left-arrow" width="16" height="16" />
                {props.item.parentTitle}
              </div>
            )}
          </div>
        </td>
      ) : null}
      {/* Archived By */}
      {props.isColumns.isArchivedBy ? (
        <td>
          <ProfileWithName
            sKey={props.item || props.item.id}
            nameIntial={getIntials(props.item.archivedBy)}
            personName={getName(props.item.archivedBy)}
            profile={props.item.archivedBy.profile.image}
            isPopover={props.isColumns.isPopover}
            role={
              props.item.archivedBy.profile
                ? props.item.archivedBy.profile.role.name
                : ""
            }
          />
        </td>
      ) : null}
      {/* Archived On */}
      {props.isColumns.isArchivedOn ? (
        <td className="text-col-3">{props.item.archivedOn}</td>
      ) : null}

      {/* Created On */}
      {props.isColumns.isCreatedOn ? (
        <td>{getParsedDate(props.item.createdTs)}</td>
      ) : null}

      {/* Tag management - Categpry name */}
      {props.isColumns.isCategoryName ? <td>{props.item.category.name}</td> : null}

      {/* Description */}
      {props.isColumns.isDescription ? (
        <td className="text-col-3">{props.item.description}</td>
      ) : null}

      <td>
      {/* Dropdown */}
      {props.isColumns.isDropDown ? (
        props.isFolder ? (
          getContentRole(props.userRoleId)[0] ? (
            <Dropdown
              documentId={props.item.id}
              folderId={props.item.folderId}
              isArchivedDropdown={props.isColumns.isArchivedDropdown}
              // restoreHandler={() => props.restoreHandler(props.item.id)}
              // deleteHandler={() => props.deleteHandler(props.item.id)}
              contentAccess={getContentRole(props.userRoleId)[1]}
              handleEdit={(e) => {
                e.preventDefault();
                props.setEditFolder(true, props.item);
              }}
              handleShare={(e) => {
                e.preventDefault();
                props.setShareFolder(props.item);
              }}
              handleArchive={() => {
                const id = props.item.id || props.item.folderId;
                props.setArchiveModalVisibility(true, props.item.title, id);
              }}
              // isDocumentTemplate={props.isDocumentTemplate}
              // templateEditHandler={(event) =>
              //   props.templateEditHandler(event, props.item.id)
              // }
              // templateDeleteOpenHandler={() =>
              //   props.templateDeleteOpenHandler(
              //     props.item.id,
              //     props.item.title
              //   )
              // }
            />
          ) : null
        ) : (
          <Dropdown
            documentId={props.item.id}
            folderId={props.item.folderId}
            isArchivedDropdown={props.isColumns.isArchivedDropdown}
            // restoreHandler={() => props.restoreHandler(props.item.id)}
            // deleteHandler={() => props.deleteHandler(props.item.id)}
            // handleShare={(e) => {
            //   e.preventDefault();
            //   props.setShareFolder(props.item);
            // }}
            // handleArchive={() => {
            //   const id = props.item.id || props.item.folderId;
            //   props.setArchiveModalVisibility(true, props.item.title, id);
            // }}
            isDocumentTemplate={props.isDocumentTemplate}
            isTagManagement={props.isTagManagement}
            handleEdit={props.handleEdit}
            handleDelete={props.handleDelete}
            handleActivateDeactivate={props.handleActivateDeactivate}
            tag={props.item}
            templateEditHandler={(event) =>{
              event.stopPropagation();
              props.templateEditHandler(event, props.item.id)
            }}
            
            
            statusHandler = { () =>


              {props.item.status.name === "Active" ?
                props.setStatus(
                props.item.id,
                props.item.status.name,
                props.item.title,) : 

                props.setStatus(
                  props.item.id,
                  props.item.status.name,
                  props.item.title
                )

              }
            

            }
            
            templateDeleteOpenHandler={() =>
              props.templateDeleteOpenHandler(props.item.id, props.item.title)
            }

          
          documentType = {props.isDocumentTemplate && props.item.status.name === "Active" ? "Deactivate Template" : "Activate Template"}

        
            

          />
        )
      ) : null}
      </td>
    </tr>
  );
};

export default listViewRows;


